import { useEffect, useRef, useState } from "react";

const ROW_HEIGHT = 20;
const SPREAD_ROW_HEIGHT = 36;
const MOBILE_ROW_HEIGHT = 20;
const MOBILE_SPREAD_ROW_HEIGHT = 30;
const MIN_ROWS = 4;

function calcRowCount(
	height: number,
	viewMode: "both" | "bids" | "asks",
	rowHeight = ROW_HEIGHT,
	spreadRowHeight = SPREAD_ROW_HEIGHT,
): number {
	if (height < 50) return -1;
	const available = viewMode === "both" ? height - spreadRowHeight : height;
	const rows = Math.max(MIN_ROWS, Math.floor(available / rowHeight));
	return viewMode === "both" ? Math.floor(rows / 2) : rows;
}

export function useOrderbookRowCount(viewMode: "both" | "bids" | "asks") {
	const containerRef = useRef<HTMLDivElement>(null);
	const [rowCount, setRowCount] = useState(14);

	useEffect(() => {
		const el = containerRef.current;
		if (!el) return;

		const getDimensions = () => {
			const isDesktop = window.matchMedia("(min-width: 640px)").matches;
			return {
				rowHeight: isDesktop ? ROW_HEIGHT : MOBILE_ROW_HEIGHT,
				spreadRowHeight: isDesktop
					? SPREAD_ROW_HEIGHT
					: MOBILE_SPREAD_ROW_HEIGHT,
			};
		};

		// Calculate immediately for viewMode changes
		const updateRowCount = (height: number) => {
			const { rowHeight, spreadRowHeight } = getDimensions();
			const count = calcRowCount(height, viewMode, rowHeight, spreadRowHeight);
			if (count > 0) setRowCount(count);
		};

		updateRowCount(el.clientHeight);

		const observer = new ResizeObserver((entries) => {
			updateRowCount(entries[0].contentRect.height);
		});

		observer.observe(el);
		return () => observer.disconnect();
	}, [viewMode]);

	return { containerRef, rowCount };
}
